/**
 * Specifies what kind of stimulus is being described.
 * @readonly
 * @enum {string}
 */
const STIMULUS_TYPE = {
    TEXT: 'Text',
    IMAGE: 'Image',
    UPLOAD: 'Upload', // Virtual type used to setup file uploads of various sorts
    VIDEO: 'Video',
    IMAGE_BATCH: 'ImageBatch',
    COLLECTION: 'Collection',
    SCREENSHARE: 'ScreenShare'
};

export default STIMULUS_TYPE;
